import type { AccountRelatedContact } from './types';

// Made-up related contacts so the list can be reviewed before svc-contracting serves them. Delete with the API wiring.
export const SAMPLE_RELATED_CONTACTS: ReadonlyArray<AccountRelatedContact> = [
  {
    id: 'sample-related-contact-1',
    name: 'Alex Example',
    accountName: 'Example Harbour Hotel',
    accountRecordType: 'Accommodation',
    title: 'Director of Sales and Marketing',
    email: 'alex.example@example.com',
    mobilePhone: '+61 400 555 001',
    phone: '+61 2 5550 1001',
    isPrimary: true,
    roles: ['Decision Maker'],
  },
  {
    id: 'sample-related-contact-2',
    name: 'Blair Sample',
    accountName: 'Example Harbour Hotel',
    accountRecordType: 'Accommodation',
    title: 'Revenue Manager',
    email: 'blair.sample@example.com',
    mobilePhone: null,
    phone: '+61 2 5550 1002',
    isPrimary: false,
    roles: [],
  },
  {
    id: 'sample-related-contact-3',
    name: 'Indigo Template',
    accountName: 'Example Hotels Group',
    accountRecordType: 'Accommodation',
    title: 'Area Director of Revenue',
    email: 'indigo.template@example.com',
    mobilePhone: '+61 400 555 009',
    phone: null,
    isPrimary: false,
    roles: ['Influencer', 'Evaluator'],
  },
  {
    id: 'sample-related-contact-4',
    name: 'Jordan Dummy',
    accountName: 'Example Hotels Group',
    accountRecordType: 'Accommodation',
    title: null,
    email: 'jordan.dummy@example.com',
    mobilePhone: null,
    phone: '+61 2 5550 1010',
    isPrimary: false,
    roles: [],
  },
  {
    id: 'sample-related-contact-5',
    name: 'Casey Placeholder',
    accountName: 'Example Harbour Hotel',
    accountRecordType: 'Accommodation',
    title: 'General Manager',
    email: null,
    mobilePhone: '+61 400 555 003',
    phone: null,
    isPrimary: false,
    roles: [],
  },
];
